import { FormFieldPresentationPropsCommon } from "@insite/mobius/FormField/FormField";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import get from "@insite/mobius/utilities/get";
import Color from "color";
import { css } from "styled-components";

type BorderKind = FormFieldPresentationPropsCommon["border"];

export const disabledByType = ({ border, theme }: { border: BorderKind; theme: BaseTheme }) => {
    if (border === "rectangle" || border === "rounded") {
        const disabledBkg = Color(get(theme, "colors.common.disabled"))
            .rgb()
            .mix(Color(get(theme, "colors.common.background")), 0.8)
            .toString();
        return css`
            background: ${disabledBkg};
            color: ${get(theme, "colors.common.disabled")};
            /* Removed - FormFieldIcon Selectors */
        `;
    }
    return "border-bottom-style: dotted;";
};
